import React, { useState, useEffect } from "react";
import Tabbar from "../base/Tabbar";
import Trigger from "./Trigger";
import TriggerHistory from "./TriggerHistory";
import { DataState } from "./../../context/DataProvider";
import { SiNetcup } from "react-icons/si";
import WorkflowList from "../workflow3/WorkflowList";

const MainForm = ({setWorkflowType}) => {
  const { handleCreateTask } = DataState();
  const [selectedTab, setSelectedTab] = useState("triggers");
  const handleSelectTab = (tab) => {
    setSelectedTab(tab);
    if (setWorkflowType){
      if (tab == "workflows") {
        setWorkflowType("workflow");
      } else {
        setWorkflowType("bot")
      }
    }
  };

  return (
    <div className="max-w-3xl w-full mx-auto h-full pt-10">
      <div className="pt-2 w-full">
        <div className="flex p-1 gap-1 bg-3 max-sm:text-xs rounded-full br-1 border w-fit mx-auto">
          <button
            onClick={() => handleSelectTab("triggers")}
            className={`flex items-center gap-1 disabled:cursor-not-allowed min-h-6 px-3 py-1 rounded-full border-0 text-xs transition-all duration-200 ${
              selectedTab === "triggers"
                ? "bg-1 hover:text-s-text text-p-text font-semibold"
                : "bg-transparent hover:text-s-text text-p-text font-normal"
            }`}
          >
            <span>Workflows</span>
          </button>
          <button
            onClick={() => handleSelectTab("workflows")}
            className={`flex items-center gap-1 disabled:cursor-not-allowed min-h-6 px-3 py-1 rounded-full border-0 text-xs transition-all duration-200 ${
              selectedTab === "workflows"
                ? "bg-1 hover:text-s-text text-p-text font-semibold"
                : "bg-transparent hover:text-s-text text-p-text font-normal"
            }`}
          >
            <span>Graph Workflows</span>
          </button>
          <button
            onClick={() => handleSelectTab("history")}
            className={`flex items-center gap-1 disabled:cursor-not-allowed min-h-6 px-3 py-1 rounded-full border-0 text-xs transition-all duration-200 ${
              selectedTab === "history"
                ? "bg-1 hover:text-s-text text-p-text font-semibold"
                : "bg-transparent hover:text-s-text text-p-text font-normal"
            }`}
          >
            <span>History</span>
          </button>
        </div>
        {selectedTab === "triggers" && <Trigger />}
        {selectedTab === "history" && <TriggerHistory />}
        {selectedTab === "workflows" && <WorkflowList/>}
      </div>
    </div>
  );
};

export default MainForm;